export var wasserbuchStyle = `<style>
      .digiwab_background {
        background-color: white;
    }
    
    
    /* Standard: Schriftart und -groesse */
    body,a,div,h1,h2,h3,li,p,table,th,tr,td,ul {
        font-size: 12px;
    }
    *[onclick]{cursor:pointer;}
    a{cursor: pointer;}
    a:link {
        color: #003366;
        text-decoration: none;
    }
    
    a:visited {
        color: #003366;
        text-decoration: none;
    }
    
    a:hover {
        color: #003366;
        text-decoration: underline;
    }
    
    a:active {
        color: #003366;
        text-decoration: none;
    }
    
    /* links in schwarz, nie unterstrichen, fuer sitemap */
    a.sitemap:link {
        color: #000000;
        text-decoration: none;
    }
    
    a.sitemap:visited {
        color: #000000;
        text-decoration: none;
    }
    
    a.sitemap:hover {
        color: #000000;
        text-decoration: none;
    }
    
    a.sitemap:active {
        color: #000000;
        text-decoration: none;
    }
    
    /* links in weiss, nie unterstrichen, fuer menue */
    a.white:link {
        color: #FFFFFF;
        font-size: 11px;
        text-decoration: none;
    }
    
    a.white:visited {
        color: #FFFFFF;
        font-size: 11px;
        text-decoration: none;
    }
    
    a.white:hover {
        color: #FFFFFF;
        font-size: 11px;
        text-decoration: none;
    }
    
    a.white:active {
        color: #FFFFFF;
        font-size: 11px;
        text-decoration: none;
    }
    
    body {
        background-color: #fff;
        color: #000000;
        margin: 0px;
    }
    body.bgwhite {
        background-color: #FFFFFF;
        color: #000000;
        margin: 0px;
    }
    body.blue {
        background-color: #E4EDF5;
        color: #000000;
    }
    
    body.darkblue {
        background-color: #003366;
        color: #000000;
        margin: 0px;
        margin-left: 5px;
        margin-top: 0px;
    }
    
    form,select,textarea {
        font-size: 11px;
        margin: 0px;
        margin-left: 0px;
        margin-top: 0px;
    }
    
    h1 {
        color: #003366;
        font-size: 14px;
        margin: 10px 0px 5px 0px;
    }
    
    h2 {
        color: #003366;
        font-size: 12px;
        margin: 5px 0px 3px 0px;
    }
    h3 {
        color: #003366;
        font-size: 11px;
        margin: 5px 0px 3px 0px;
    }
    
    hr{
        color: #003366;
        height: 2px;
        text-align: center;
        width: 100%;
    }
    
    input{
        color: #003366;
        font-size: 11px;
    }
    
    input.button{height:26px; margin-top:-3px;}
    
    span.btWrapper{position:relative; height:26px; padding:0;display: inline-block;}
    
    
    
    span.btWrapper input.button{
        border: none;
        color: #15428b;
        height: 26px;
        cursor: pointer;
        margin-top:-3px;
        float:left;
    }
    
    span.btLeft{
        border: none;
        color: #15428b;
        height: 26px;
        width:4px;
        display:block;
        left:0;
        top:0;
        position: absolute;
        margin-top:-3px;
    }
    
    span.btWrapperRo:hover input.button.roNew,span.btWrapperRo:hover input.button.roNew ~ span.btLeft, span.btWrapperRo:hover span.btLeft, span.btWrapperRo input.button.roNew,span.btWrapperRo input.button.roNew ~ span.btLeft{
        color: #959191 !important;
    }
    
    
    input.button.roNew, input.button.roNew ~ span.btLeft{
        color: #959191 !important;
    }
    
    
    input.auswButton{
        background-color: #E4EDF5;
        border: #003366 2px solid;
        color: #003366;
        width: auto;
        font-weight: bold;
    }
    
    input.disabled {
        background-color: #F8F8FE;
    }
    
    input.searchStatus {
        background-color: #fff;
        color: #003366;
        border: 0px;
        width: 200px;
        text-align: right;
    }
    
    p {
        background-color: #ffffff;
        color: #000000;
    }
    
    p.sitemap {
        color: #003366;
    }
    
    table,td,tr {
        margin: 0px;
        vertical-align: top;
    }
    input {
        margin: 0px;
    }
    th {
        color: #003366;
        background-color: #E7E7E7;
        border: solid #003366;
        border-right-width: 1px;
        border-top-width: 1px;
        border-left-width: 0px;
        border-bottom-width: 1px;
    }
    table.rand {
        border: solid #003366;
        border-right-width: 1px;
        border-top-width: 1px;
        border-left-width: 2px;
        border-bottom-width: 2px;
    }
    .gitter {
        border: solid #003366;
        border-right-width: 1px;
        border-top-width: 1px;
        border-bottom-width: 0px;
        border-left-width: 0px;
    }
    
    
    span.status0, span.status1, span.status2, span.status3{
        width: 14px; border-width: 1px;
        float:left;width:5px;margin:0 5px 0 2px;
    }
    
    
    td.blaettern {
        color: #003366;
    }
    
    /* tabellenzellen mit blauem hintergrund */
    td.blue {
        background-color: #E4EDF5;
        border: 0px;
        color: #000000;
        vertical-align: top;
    }
    
    td.center {
        vertical-align: middle;
    }
    
    /* tabellenzellen mit dunkelblauem hintergrund */
    td.darkblue {
        background-color: #124B9D;
        border: 0px;
        text-align: left;
        vertical-align: top;
    }
    
    /* tabellenzellen mit dunkelblauer schrift und hellblauem hintergrund */
    td.head {
        border: 0px;
        color: #124B9D;
        font-size: 11px;
        vertical-align: middle;
    }
    td.footer{
        color: #003366;
        font-size: 10px;
        vertical-align: middle;
    }
    td.lightblue {
    }
    
    .lightblue {
    }
    
    /* tabellenzellen mit blauem hintergrund fuer menue links */
    td.menu {
        background-color: #5C8BC0;
        border: 0px;
        color: #FFFFFF;
        font-size: 11px;
        text-align: left;
        vertical-align: top;
    }
    
    /* tabellenzellen mit rotem hintergrund fuer menue links */
    td.red {
        background-color: #ff0000 !important;
        border: 0px;
        color: #FFFFFF;
        font-size: 11px;
        text-align: left;
        vertical-align: top;
    }
    
    /* fuer tabellenzellen in sitemap */
    td.sitemap {
        background-color: #E4EDF5;
        border: 0px;
        color: #000000;
        text-align: left;
    }
    
    /* tabellenzellen mit hintergrundbildern, schriftfarbe weiss */
    td.verlauf {
        border: 0px;
        color: #003366;
        font-size: 11px;
        font-weight: bold;
    }
    
    /* fuer tabellenzellen mit weissem hintergrund */
    td.white {
        background-color: #FFFFFF;
        border: 0px;
        color: #000000;
        text-align: left;
    }
    
    
    .abstand {
        margin-right: 10px;
    }
    
    .seplinie {
        background-color: #003366;
    }
    
    .subheadline {
        color: #003366; /*color: #333;*/
        font-weight: bold;
    }
    
    /* dunkelblauer text */
    .txtdarkblue {
        color: #003366;
        font-size: 12px;
    }
    
    .txtinput {
        font-size: 11px;
        margin: 0px;
        margin-left: 0px;
        margin-top: 0px;
    }
    .disabledTxtinput {
        font-size: 11px;
        margin: 0px;
        margin-left: 0px;
        margin-top: 0px;
        color: #003366;
    }
    .level1 {
        font-weight: bold;
        color: #003366;
        padding: 10px 0px 0px 0px;
    }
    
    .level3{
        font-weight:normal;
    }
    
    .level3.b{
        font-weight:bold;
    }
    
    .digiWabSz {
        font-weight: bold;
        color: #003366;
    }
    
    .butBemerkung {
        padding: 1px 5px;
        border: thin solid #003366;
    }
    
    #pageBox {
        text-align: left
    ;
        margin: 10px;
    }
    #elementBox {
        vertical-align: middle;
        margin: 10px 0px;
    }
    
    .mussFeld {  background-color: #FFCC66}
    
    
    
    .ausgabetab {
        background-color: #F8F8FE;
        border-collapse: collapse;
        color:#003388;
        font-size: 11px;
        width: 100%;
        border-left: solid 1px #5B7DB4;
        border-bottom: solid 1px #5B7DB4;
    }
    
    .ausgaberowlight {
        background-color: #F8F8FE;
        color:#003388;
        font-size: 11px;
        border-bottom: solid 1px #E4EDF5;
        border-right: solid 1px #E4EDF5;
        border-top: solid 1px #E4EDF5;
        border-left: solid 1px #E4EDF5;
        padding: 0px 5px 0px 5px;
    }
    
    .ausgaberowdark {
        background-color: #D3E1ED;
        color:#003388;
        font-size: 11px;
        border-bottom: solid 1px #E4EDF5;
        border-right: solid 1px #E4EDF5;
        border-top: solid 1px #E4EDF5;
        border-left: solid 1px #E4EDF5;
        padding: 0px 5px 0px 5px;
    }
    
    td.ausgaberow{
        color:#003388;
        font-size: 11px;
        border-bottom: solid 1px #7290BE;
        border-right: solid 1px #7290BE;
        border-top: solid 1px #7290BE;
    }
    
    span.ausgabe {
        font-size: 11px;
    }
    
    /* Inhalt */
    .inhalt {
        position: relative;
        display: block;
        width: 600px;
        height: 155px;
        background-color: #e4edf5;
        overflow: auto;
        clear: left;
        /* z-index:55; */
    }
    
    
    div.ctb{margin:0;width:900px; padding:0;}
    .ctbrow{display:block; width:900px; border-collapse:collapse;}
    div.ctb div.ctbrow{border:1px solid #003366; border-width: 0 0 1px 0; padding: 0;}
    .ctbitem{border:1px solid #003366; border-width: 0 1px 0 0; padding:3px 2px; }
    .ctbitem div{overflow:hidden !important; position:relative;}
    .ctb1 div{width:65px;}
    .ctb2 div{width:25px; text-align:center;}
    .ctb3 div{width:120px;}
    .ctb4 div{width:120px;}
    .ctb5 div{width:130px;}
    .ctb6 div{width:120px;}
    .ctb7 div{width:210px;}
    .ctb8 div{width:50px;}
    .ctb8{border-width:0; padding: 3px 2px 3px 15px;}
    .ctbrow.head{border-right:1px solid #003366;}
    
    .ctbrow.head div{color:#003366; font-weight:bold; }
    
    .smalTD{display:inline-block;width:150px; overflow:hidden;}
    
    
    #loadingBox{}
    
    #loadingBox td{text-align:center; width:900px;}
    #loadingBox .outBox{display:inline-block; width:270px; height:52px; position:relative; background:#fff; text-align:left;}
    #loadingBox .outBox .inBox{display:block; width:260px; position:absolute; top:5px;bottom:5px;left:5px;right:5px; border: 1px solid #ccc; padding:5px;}
    #loadingBox .outBox .inBox img{float:left; margin: 0 10px 0 0;}
    
    div#tableErg{border:1px solid #003366; border-width: 2px 1px 2px 2px;}
    
    div.ctb div.cb{clear: both; height:1px; display:block;margin:0;padding:0;}
    
    /*
    html5doctor.com Reset Stylesheet
    v1.5
    Last Updated: 2010-08-12
    Author: Richard Clark - http://richclarkdesign.com
    Twitter: @rich_clark
    */
    
    html, body, div, span, object, iframe,
    h1, h2, h3, h4, h5, h6, p, blockquote, pre,
    abbr, address, cite, code,
    del, dfn, em, img, ins, kbd, q, samp,
    small, strong, sub, sup, var,
    b, i,
    dl, dt, dd, ol, ul, li,
    fieldset, form, label, legend,
    table, caption, tbody, tfoot, thead, tr, th, td,
    article, aside, canvas, details, figcaption, figure,
    footer, header, hgroup, menu, nav, section, summary,
    time, mark, audio, video {
        margin:0;
        padding:0;
        border:0;
        outline:0;
        vertical-align:baseline;
        background:transparent;
    }
    
    body {
        line-height:1;
    }
    
    article,aside,canvas,details,figcaption,figure,
    footer,header,hgroup,menu,nav,section,summary {
        display:block;
    }
    
    nav ul {
        list-style:none;
    }
    
    blockquote, q {
        quotes:none;
    }
    
    blockquote:before, blockquote:after,
    q:before, q:after {
        content:'';
        content:none;
    }
    
    a {
        margin:0;
        padding:0;
        font-size:100%;
        vertical-align:baseline;
        background:transparent;
    }
    
    a {
        margin:0;
        padding:0;
        font-size:100%;
        vertical-align:baseline;
        background:transparent;
    }
    
    ins {
        background-color:#ff9;
        color:#000;
        text-decoration:none;
    }
    
    mark {
        background-color:#ff9;
        color:#000;
        font-style:italic;
        font-weight:bold;
    }
    
    del {
        text-decoration: line-through;
    }
    
    abbr[title], dfn[title] {
        border-bottom:1px dotted #000;
        cursor:help;
    }
    
    table {
        border-collapse:collapse;
        border-spacing:0;
    }
    
    hr {
        display:block;
        height:1px;
        border:0;
        border-top:1px solid #cccccc;
        margin:4px 0 10px 0;
        padding:0;
    }
    
    input, select {
        vertical-align:middle;
    }
    
    
    .fontface { font-family:Arial,Helvetica,sans-serif; }
    
    
    /*
    \tThe CSS3 Text-Shadow property contains the following values
    \thorizontal-offset (length, required) | vertical-offset (length, required) | blur-radius (length, optional) | shadow-color (color, optional)
    */
    
    .shadow {\ttext-shadow:1px 1px 1px #666;
    }/*<-- edit the color you wish to use in your shadows */
    
    .shadow_multiple {text-shadow: -2px -2px 0px #1fd31f,
    2px 2px 0px #1f9ad3;
    }
    
    .rounded {
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
        border:1px solid #ccc;
    
    }
    
    .rounded_top_right {
        border-top-right-radius:5px;
        -moz-border-radius-topright:5px;
        -webkit-border-top-right-radius:5px;
        border:1px solid #ccc;
    
    }
    
    .box_shadow {
        -webkit-box-shadow: 1px 1px 3px #ccc;
        -moz-box-shadow: 1px 1px 3px #ccc;
        box-shadow: 1px 1px 3px #ccc;
    
    }
    .box_shadow_multiple {
        -webkit-box-shadow: 0 0 20px #ccc inset,
        10px 7px 15px #f0f961,
        -10px 7px 15px #55fc6d,
        -10px -7px 15px #55d7fc,
        10px -7px 15px #fc9c9c;
    
        -moz-box-shadow: 0 0 20px #ccc inset,
        10px 7px 15px #f0f961,
        -10px 7px 15px #55fc6d,
        -10px -7px 15px #55d7fc,
        10px -7px 15px #fc9c9c;
    
        box-shadow:\t\t0 0 20px #ccc inset,
        10px 7px 15px #f0f961,
        -10px 7px 15px #55fc6d,
        -10px -7px 15px #55d7fc,
        10px -7px 15px #fc9c9c;
    }
    
    .rotate {
        -webkit-transform: rotate(180deg);
        -moz-transform: rotate(-180deg);
        filter:progid:DXImageTransform.Microsoft.BasicImage(rotation=2);
        /* possible properties for the Internet Explorer filter rotation are: 1. Content is rotated 90 degrees.
            \`\t\t\t\t\t\t\t\t\t\t\t\t\t\t \t\t  2. Content is rotated 180 degrees.
                                                                               3. Content is rotated 270 degrees.
        */
    }
    
    .gradient {
        background: #f3c5bd; /* old browsers */
    
        background: -moz-linear-gradient(top, #f3c5bd 0%, #e86c57 50%, #ea2803 51%, #ff6600 75%, #c72200 100%); /* firefox */
    
        background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,#f3c5bd), color-stop(50%,#e86c57), color-stop(51%,#ea2803), color-stop(75%,#ff6600), color-stop(100%,#c72200)); /* webkit */
    
        filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f3c5bd', endColorstr='#c72200',GradientType=0 ); /* ie */
    
        /* generated with http://www.colorzilla.com/gradient-editor/ */
    }
    .gradient_radial {
        background: -moz-radial-gradient(#eee, #ccc);
    }
    
    
    body {
        background:#fff;
        color:#000;
        font:12px Arial, Helvetica, sans-serif;
        position:relative;
    }
    
    
    /* ** ** Common Addative Classes ** ** */
    .left, .float_left  { float:left\t}
    .right, .float_right { float:right\t}
    .clear { clear:both; display:block; overflow:hidden; visibility:hidden; height:0px;}
    .clear-left, .clear_left { clear:left; } .clear-right, .clear_right { clear:right; }
    .hide  { display:none\t} .block {display:block !important;} .inline {display:inline !important;}
    
    .align_right    { text-align:right;\t  }
    .align_left     { text-align:left;\t  }
    .align_center   { text-align:center;  }
    .align_justify  { text-align:justify; }
    
    .bold {font-weight:600;}
    .italic {font-style:italic;}
    
    a {\tcolor:#525252;\t}
    a:hover, a:focus { text-decoration:underline;}
    a:active, a:visited { }
    
    blockquote {
        font-family: Georgia,"Times New Roman", Times, serif;
        margin:5px;
        padding:10px;
        font-size:1.52em;
        color:#999;
        font-style:italic;
        line-height:1.3em;
        width:100%;
        quotes:none;
    }
    blockquote.left {border-right:1px dashed #ccc; width:35%;} /* float blockquote left, and set width */
    blockquote.right {border-left:1px dashed #ccc; width:35%;} /* float blockquote right and set a width */
    
    /* ** ** Header Styles ** ** */
    h1, h2, h3, h4, h5 {margin:0 0 0.5em; line-height:1.1em;}
    h1 {\tfont-size:2.52em;}
    h2 {\tfont-size:1.952em;}
    h3 {\tfont-size:1.652em;}
    h4 {\tfont-size:1.452em;}
    h5 {\tfont-size:1.252em;}
    h6 {\tfont-size:1.52em;}
    
    /* ** ** ul li's ** ** */
    ul{
        list-style:outside disc;
    }
    ul,ol{
        margin:0 0 1.5em 1.5em;
        padding:0;
    }
    li ul,li ol{
        padding:0;
        margin:0 0 1.5em 1.5em;
    }
    
    
    /* ** ** custom select color ** ** */
    
    /* ** ** paragraph styling ** ** */
    p {margin:0 0 1.52em;}
    p img.left {float:left;margin:1.52em 1.52em 1.52em 0;padding:0;}
    p img.right {float:right;margin:1.52em 0 1.52em 1.52em;}
    
    strong   \t\t{\tfont-weight:600;}
    em, dfn  \t\t{\tfont-style:italic;}
    dfn \t \t\t{   font-weight:600;}
    sup, sub \t\t{   line-height:0;}
    abbr, acronym   {\tborder-bottom:1px dashed #ccc;}
    address \t\t{\tmargin:0 0 1.5em;font-style:italic;}
    del \t\t\t{\tcolor:#666;}
    pre, code, tt   {\tfont:1em 'andale mono', 'lucida console', monospace;line-height:1.5; display:block;}
    code \t\t\t{\tbackground-color:#eee; display:inline; padding:0px 2px 1px 2px; line-height:1.1em;}
    pre \t\t\t{\tmargin:1.5em 0;white-space:pre;}
    
    .col {
        margin-left:10px; margin-right:10px;
        display: inline;
        overflow: hidden;
        float: left;
        position: relative;
    }
    
    .row{
        width: 960px;
        margin: 0 auto;
        overflow: hidden;
    }
    .row .row {
        margin: 0 -10px;
        width: auto;
        display: inline-block;
    }
    
    /* Column widths, and element width based on grid */
    
    .col_1, .width_1\t {\twidth:40px;\t }
    .col_2, .width_2 \t {\twidth:100px; }
    .col_3, .width_3 \t {\twidth:160px; }
    .col_4, .width_4 \t {\twidth:220px; }
    .col_5, .width_5\t {\twidth:280px; }
    .col_6, .width_6\t {\twidth:340px; }
    .col_7, .width_7\t {\twidth:400px; }
    .col_8, .width_8\t {\twidth:460px; }
    .col_9, .width_9 \t {\twidth:520px; }
    .col_10, .width_10\t {\twidth:580px; }
    .col_11, .width_11\t {\twidth:640px; }
    .col_12, .width_12\t {\twidth:700px; }
    .col_13, .width_13\t {\twidth:760px; }
    .col_14, .width_14\t {\twidth:820px; }
    .col_15, .width_15\t {\twidth:880px; }
    .col_16, .width_16\t {\twidth:940px; }
    
    .posr{position:relative;}
    
    
    input[type="text"]{
        border: 1px solid #749DBD !important;
        height:13px;
        padding:2px;
    }
    
    select{height:19px; border: 1px solid #749DBD !important;}p
                                                              select[multiple],select[size]{height:auto; border: 1px solid #749DBD !important;}
    
    
    
    h1,td{text-align:left;}
    
    
    ul, li{list-style: none;}
    
    table{
        border:none;
        border-collapse:collapse;
        border-spacing:0;
        width:100%;
    }
    
    .w100p{width:100%;}
    .w95p{width:95%;}
    .w96p{width:96%;}
    .w97p{width:97%;}
    
    .w98p{width:98%;}
    .w99p{width:99%;}
    .w94p{width:94%;}
    .w93p{width:93%;}
    .w92p{width:92%;}
    .w90p{width:90%;}
    
    .borderx{border:1px solid #9DBCDA; background:#fff; padding:15px; margin:10px 0 25px 0;}
    
    .dataTables_scrollBody table tr td a img{margin: 0 1px; height:16px; width:16px;}
    
    #docTable .tdtool > a{float:left;}
    
    th, td{padding:2px; vertical-align: top; line-height: 14px;}
    body{
        text-align: left;
        font-familie: Arial,​Helvetica,​sans-serif;
    }
    body.bdb{
        text-align: center;
    }
    
    body.popup{
        background: none repeat scroll 0 0 #F4F7FB;
        border: 0px solid #9DBCDA;
        padding:10px;
    }
    
    .tablex{overflow: hidden; border: 2px solid #9DBCDA;  padding: 3px 5px 10px 8px;background: #fff;}
    .tablex tbody tr:nth-child(odd) {
        background-color: #E3EDF7;
    }
    
    header{height:80px; overflow:hidden;}
    
    .tablex tbody tr td{
        border:1px solid #9DBCDA;
    }
    
    #navx{
        background: none repeat scroll 0 0 #cbddf8;
        border-top: 1px solid #808080;
        display: block;
        height: 37px;
        padding: 0;
        width: 100%;
        z-index: 100;
    }
    
    #userx .submit{
        position: absolute; left: -9999px; width: 1px; height: 1px;
    }
    
    #bdbox, #versionBox{
        margin: 0 auto;
        overflow: visible;
        text-align: left;
        width: 980px;
        padding:0 10px  10px;
    }
    
    #versionBox{text-align:right;  padding:5px 10px  10px;\t}
    
    .bdb #bdbox{
        background: none repeat scroll 0 0 #ffffff;
        margin: 0 auto;
        padding: 0;
        text-align: left;
        width: 1000px;
    }
    
    
    #conx{
        position: relative;
    }
    
    
    #titlex{height:0;}/*50px*/
    
    #sectionx{padding:30px; margin:0 0 0 0; }
    
    
    .tipa a{text-decoration: underline;}
    
    
    
    
    #conx label{font-weight:normal;}
    .hd{display:none !important;}
    .tar{text-align:right;}
    .tal{text-align:left;}
    .tac{text-align:center;}
    
    .fr{float:right;}
    .fl{float:left;}
    .cb{clear:both;}
    .vm{vertical-align:middle;}
    .b{font-weight:bold !important;}
    
    #contwrapper{position: relative;}
    #navx nav{
        height:35px;
        z-index: 100;
    }
    #navx nav ul.level_1{margin:0;}
    
    .msize{width:200px;}
    
    .ui-autocomplete li{
        list-style:none;
    }
    
    .ui-autocomplete {
        padding-right: 3px;
        text-align:left;
        list-style:none;
        height:200px;
        overflow:hidden;
        overflow-x:hidden;
        overflow-y:auto;
    
    }
    
    .ui-autocomplete .ui-menu-item a {
        padding: 0 0 0 1px;
    }
    
    table td.noborder{border-width:0 !important;}
    
    
    header #userx{height:70px; width:260px; position:relative;padding:5px 10px;}
    header #loginx{position: absolute; bottom:0;right:10px; height:20px;}
    header #loginx img{margin:0 5px 0 0;float:left;}
    header .lgbx{margin:55px 0 0 0;}
    #userx form{padding:0 50px 0 0;}
    
    fieldset {padding:20px;background: #fff;margin:30px 0 40px 0;}
    
    fieldset> table{width:70%;}
    
    #loginMask input, #loginMask label{height:15px; font-size: 12px; margin:0 0 2px 0;}
    #loginMask label{width:60px; display: inline-block; text-align: left;}
    #loginMask div{margin:0;bottom:0;padding:0;}
    
    #headx .tipa{margin:3px 15px 0 0; font-size: 12px;}
    
    #wbbNv{height:46px; padding:0;margin:0; }
    #wbbNv.part0{background-position: 0 0;}
    #wbbNv.part1{background-position: 0 -57px;}
    #wbbNv.part2{background-position: 0 -113px;}
    #wbbNv.part3{background-position: 0 -168px;}
    #wbbNv.part4{background-position: 0 -224px;}
    #wbbNv.part5{background-position: 0 -280px;}
    #wbbNv.part6{background-position: 0 -336px;}
    #wbbNv li{height:46px; float:left; display: inline-block; width:132px;list-style: none; text-align: right;}
    #wbbNv li a, #wbbNv li span{padding:10px 0;color: #fff;font-size: 11px; display: block; text-align: left;  float:right;}
    #wbbNv #li_1 a, #wbbNv #li_6 a, #wbbNv #li_1 span, #wbbNv #li_6 span{width:100px;}
    #wbbNv #li_3 a, #wbbNv #li_3 span{width:80px;}
    #wbbNv #li_5 a{padding-right:5px !important;}
    #wbbNv #li_7 a{padding-right:8px !important;}
    
    
    .seplinie{height:14px; padding:2px; border:1px solid #7290BE; background: transparent;}
    .seplinie img{height:14px; display:block; width:100%; background: #D3E1ED;}
    
    .sep_invis{height: 14px;}
    
    
    
    #nvfix{position: absolute; left:0; right:0; width:960px; top:30px; height:500px; border: none; background:#fff;z-index: 1;}
    #cssmenu{position: relative}
    #cssmenu ul.level_1 {}
    #cssmenu li {}
    #cssmenu a {}
    #cssmenu ul{list-style: none;}
    #cssmenu a{text-decoration: none;}
    
    #cssmenu > ul > li {
        position: relative;
        float: left;
        overflow: visible;
        display: block;
        font-size: 12px;
        padding: 0 0 15px 0;
        text-decoration: none;
        margin-top:5px;
        height:25px;
    }
    
    #cssmenu > ul > li > a {
        overflow: hidden;
        padding:0 0 0 15px;
        margin:0 10px 0px 10px;
        height:25px;
        display: block;
        position: relative;
        border: none;
        float:left;
        color:#000;
    }
    
    #cssmenu > ul > li > a > span{
        padding:5px 15px 0 0;
        display: block;
        height:20px;
    }
    
    
    #cssmenu > ul > li > a:hover {
        color:#003366;
        background-color: #DDEBFD;
    }
    
    
    #cssmenu > ul > li > ul {
        opacity: 0;
        position: absolute;
        top:29px;
        left:-10px;
        right:0px;
        visibility: hidden;
        background: #c1dcff;
        width:200px;
        box-shadow: 3px 3px 2px #ccc;
    }
    
    
    #cssmenu > ul > li > ul > li{
        display:block;
        background: #c1dcff;
    }
    
    
    
    #cssmenu ul ul > li:hover > ul { opacity: 1; visibility: visible;}
    
    
    #cssmenu ul ul a:hover{
        background-color: #4e77ac;
        color: #fff;
    }
    
    
    
    
    
    
    
    
    #cssmenu > ul > li:hover > ul {
        opacity: 1;
        visibility: visible;
        z-index:100;
    }
    
    #cssmenu ul ul a{
        color: rgb(50,50,50);
        padding: 5px 8px 7px 16px;
        display: block;
    }
    
    
    
    
    nav#cssmenu ul.level_1 > li:last-child span.trn{
        display: none;
    }
    
    
    
    span.trn{border-left:1px solid #a0a0a0; border-right:1px solid #fff; position:absolute; height:15px; right:0; top:5px;}
    
    
    
    
    
    #contwrapper .dataTables_scrollHead{width:880px;}
    
    .white td.lightblue{
        background-color: #fff;
        color: #000
    }
    
    
    .popup .searchStatus{visibility: hidden;}
    .bedokliste{margin:0 0 0 20px;}
    .bedokliste a{position: absolute; left:-22px; top:0;}
    .bedokliste li{position: relative;}
    
    #keybox .dd img{display:none;}
    #keybox .dataTables_wrapper{margin-bottom:15px;}
    .zuweisenx{margin:0 0 15px; text-align:right;}
    
    .blue .subheadline input[type="text"], .blue td > select{width:200px !important;}
    
    
    #wbbTable .firstCell{
        padding:0 10px 0 0; min-width: 100px;
    }
    .red{
        color:#CD2626;
    }
    
    
    #popup_message {
        text-align: left;
    }
    
    
    input[type="text"], select, textarea, .inputBG {
        border: 1px solid #749dbd;
    }
    
    .mmBox, .tablex{
        padding:2px;
        border: 1px solid #8db2e3;
    }
    
    .ui-corner-all.ui-autocomplete {border-radius:0 !important;
        background: none repeat scroll 0 0 #ffffff;
        border: 1px solid #999999;
        box-shadow: 1px 4px 3px rgba(50, 50, 50, 0.64);
        cursor: default;
        font-size: 11px;
    
    }
    
    .ui-autocomplete .ui-state-focus{background: #f0f0f0 !important;border:none !important; border-radius:0 !important; margin:0 !important;}
    
    
    .ui-autocomplete li a b{
        color: #3399ff;
        font-weight: normal;
    }
    
    .autoWrapper{position: relative;}
    
    .autoWrapper .autoZeichen{
        position: absolute;
        width:15px;
        height: 15px;
        top:1px;
        right:3px;
        background-color: #fff;
    }
    
    
    select option{border-right:1px solid #999999;}
    
    input.ui-autocomplete-input{}
    
    
    
    tr.selectTr, tr.selectTr td{
        background-color: #00688B !important;;
    }
    
    #versionTable.MMscrollTable  .status0 td, #versionAdminTable.MMscrollTable  .status0 td, #wbbTable.MMscrollTable  .status0 td, span.status0  {
        background-color: #FFFFFF;
    }
    #versionTable.MMscrollTable  .status1 td, #versionAdminTable.MMscrollTable  .status1 td,
    #wbbTable.MMscrollTable  .status1  td, span.status1{
        background-color: #FF9966;
    }
    #versionTable.MMscrollTable  .status3 td, #versionAdminTable.MMscrollTable  .status3 td,
    #wbbTable.MMscrollTable  .status3  td, span.status3{
        background-color: #FF3333;
    }
    
    #versionTable.MMscrollTable  .status2 td, #versionAdminTable.MMscrollTable  .status2 td,
    #wbbTable.MMscrollTable  .status2  td, span.status2{
        background-color: #66CC99;
    
    }
    
    
    span.status0, span.status1,span.status2,span.status3{border:1px solid #99bbe8;}
    
    ul#wbbNv.newwbb li a{text-decoration: none !important; cursor: inherit;}
    
    #wbbTable_ajax{display:none;}
    
    
    
    ul.etabs {
        list-style: outside none none;
        padding: 0 0 0 3px;
    }
    ul.etabs li {
        display: inline-block;
        float: left;
        margin-left: 2px;
        position: relative;
    }
    ul.etabs li > a {
        display: inline-block;
        padding-left: 10px;
    }
    ul.etabs li > a > span {
        display: inline-block;
        padding-right: 10px;
    }
    ul.etabs li > a > span > span {
        color: #416aa3;
        display: inline-block;
        padding: 4px 30px 5px;
        text-decoration: none;
    }
    
    ul.etabs li.hover > a > span > span {
        color: #15428b;
    }
    ul.etabs li.active {
        bottom: -1px;
        z-index: 100;
    }
    ul.etabs li.active > a {
        position: relative;
    }
    ul.etabs li.active > a > span > span {
        color: #15428b;
        font-weight: bold;
        padding: 3px 30px 6px;
    }
    div.etab_line {
        background-color: #deecfd;
        border: 1px solid #8db2e3;
        clear: both;
        display: none;
        height: 2px;
    }
    div.etab_content {
        border: 1px solid #8db2e3;
        clear: both;
        display: none;
        min-height: 300px;
        overflow: hidden !important;
        padding: 3px;
        position: relative;
    }
    div.etab_content.active {
        display: block;
    }
    .etab_top, .etab_content {
        margin: 0 10px;
    }
    
    
    #filterBox{float:left; display: inline-block;}
    
    .btWrapper.loading span, .btWrapper.loading input{display:none;}
    .btWrapper.loading::after{content:"Daten werden geladen ... "; height:26px; width:100%; line-height:26px;}
    .MMscrollTable td{overflow:hidden;}
    .bedokliste li.docIcon{position: relative;}
    .bedokliste li.docIcon > div{display:block !important;}
    .showicon_box{position: relative; margin-left:20px; display: block;}
    a.showicon_doc::before{
        position:absolute; left:-20px; top:0;
        width:20px;
        height: 20px;
        content:" ";
    }
    
    
    .whitebox {
        border:1px solid #9dbcda;
        overflow: auto;
        padding:3px 7px;
        background: #fff;
    }
    
    
    table .checkall {
        display: inline-block;
        float: left;
        height: 16px;
        line-height: 16px;
        margin: 0 1px 0 !important;
        width: 16px;
        padding:0;
    }
    
    #wbbTable_wrapper table th{cursor: default;}
    
    .pagination {
        border-radius: 4px;
        display: inline-block;
        margin: -8px 0 0 0;
        padding-left: 0;
    }
    
    .pagination > li {
        display: inline;
    }
    
    
    .pagination > li:first-child > a, .pagination > li:first-child > span {
        border-bottom-left-radius: 3px;
        border-top-left-radius: 3px;
        margin-left: 0;
    
    }
    
    .pagination > li:last-child > a, .pagination > li:last-child > span {
        border-bottom-right-radius: 3px;
        border-top-right-radius: 3px;
        margin-left: 0;
    
    }
    
    
    .pagination > li > a, .pagination > li > span {
        font-size: 12px;
        padding: 5px 10px;
        background-color: #fff;
        border: 1px solid #ddd;
        float: left;
        line-height: 1.42857;
        position: relative;
        text-decoration: none;
    }
    
    .pagination .page.active > a {
        color: red;
        font-weight: bold;
    }
    
    @media print {
        body, html {
            background-color: white !important;
            background-image: none !important;
        }
        .lightblue {
            background: white !important;
            background-color: white !important;
        }
        .versionIcon {
            display: none !important;
        }
        #printIcon {
            display: none !important;
        }
        #headx, #navx, .noprint{display:none !important;}
    
        .dataTables_scrollBody{overflow: visible !important;}
    
    
    }
    
    
    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
     * General page setup
     */
    #dt_example {
        font: 80%/1.45em "Lucida Grande", Verdana, Arial, Helvetica, sans-serif;
        margin: 0;
        padding: 0;
        color: #333;
        background-color: #fff;
    }
    
    
    #dt_example #container {
        width: 800px;
        margin: 30px auto;
        padding: 0;
    }
    
    
    #dt_example #footer {
        margin: 50px auto 0 auto;
        padding: 0;
    }
    
    #dt_example #demo {
        margin: 30px auto 0 auto;
    }
    
    #dt_example .demo_jui {
        margin: 30px auto 0 auto;
    }
    
    #dt_example .big {
        font-size: 1.3em;
        font-weight: bold;
        line-height: 1.6em;
        color: #4E6CA3;
    }
    
    #dt_example .spacer {
        height: 20px;
        clear: both;
    }
    
    #dt_example .clear {
        clear: both;
    }
    
    #dt_example pre {
        padding: 15px;
        background-color: #F5F5F5;
        border: 1px solid #CCCCCC;
    }
    
    #dt_example h1 {
        margin-top: 2em;
        font-size: 1.3em;
        font-weight: normal;
        line-height: 1.6em;
        color: #4E6CA3;
        border-bottom: 1px solid #B0BED9;
        clear: both;
    }
    
    #dt_example h2 {
        font-size: 1.2em;
        font-weight: normal;
        line-height: 1.6em;
        color: #4E6CA3;
        clear: both;
    }
    
    #dt_example a {
        color: #0063DC;
        text-decoration: none;
    }
    
    #dt_example a:hover {
        text-decoration: underline;
    }
    
    #dt_example ul {
        color: #4E6CA3;
    }
    
    .css_right {
        float: right;
    }
    
    .css_left {
        float: left;
    }
    
    
    .dataTables_wrapper {
        background: none repeat scroll 0 0 #fff;
        clear: both;
        min-height: 10px;
        padding: 3px 10px 10px;
        position: relative;
    }
    .dataTables_processing {
        background-color: white;
        border: 1px solid #ddd;
        color: #999;
        font-size: 14px;
        height: 30px;
        left: 50%;
        margin-left: -125px;
        margin-top: -15px;
        padding: 14px 0 2px;
        position: absolute;
        text-align: center;
        top: 50%;
        width: 250px;
    }
    .dataTables_length {
        float: right;
        width: 40%;
        margin: -30px 40px 0 0;
    }
    .dataTables_filter {
        float: right;
        text-align: right;
        width: 50%;
    }
    .dataTables_info {
        float: left;
        width: 60%;
    }
    .dataTables_paginate {
        float: right;
        text-align: right;
        width: 44px;
    }
    .paginate_disabled_previous, .paginate_enabled_previous, .paginate_disabled_next, .paginate_enabled_next {
        float: left;
        height: 19px;
        margin-left: 3px;
        width: 19px;
    }
    
    table.display {
        clear: both;
        margin: 0 auto;
        width: 100%;
    }
    table.display thead th {
        border-bottom: 1px solid black;
        cursor: pointer;
        font-weight: bold;
        padding: 3px 18px 3px 10px;
    }
    table.display tfoot th {
        border-top: 1px solid black;
        font-weight: bold;
        padding: 3px 18px 3px 10px;
    }
    table.display tr.heading2 td {
        border-bottom: 1px solid #aaa;
    }
    table.display td {
        padding: 3px 10px;
    }
    table.display td.center {
        text-align: center;
    }
    table.display tr.odd.gradeA {
        background-color: #ddffdd;
    }
    table.display tr.even.gradeA {
        background-color: #eeffee;
    }
    table.display tr.odd.gradeC {
        background-color: #ddddff;
    }
    table.display tr.even.gradeC {
        background-color: #eeeeff;
    }
    table.display tr.odd.gradeX {
        background-color: #ffdddd;
    }
    table.display tr.even.gradeX {
        background-color: #ffeeee;
    }
    table.display tr.odd.gradeU {
        background-color: #ddd;
    }
    table.display tr.even.gradeU {
        background-color: #eee;
    }
    tr.odd {
        background-color: #e3edf7;
    }
    tr.even {
        background-color: white;
    }
    .dataTables_scroll {
        clear: both;
        overflow:hidden;
    }
    .dataTables_scrollBody {
        min-height:25px;
    }
    .top, .bottom {
        background-color: #f5f5f5;
        border: 1px solid #cccccc;
        padding: 15px;
    }
    .top .dataTables_info {
        float: none;
    }
    .clear {
        clear: both;
    }
    .dataTables_empty {
        text-align: center;
    }
    tfoot input {
        color: #444;
        margin: 0.5em 0;
        width: 100%;
    }
    tfoot input.search_init {
        color: #999;
    }
    td.group {
        background-color: #d1cfd0;
        border-bottom: 2px solid #a19b9e;
        border-top: 2px solid #a19b9e;
    }
    td.details {
        background-color: #d1cfd0;
        border: 2px solid #a19b9e;
    }
    .example_alt_pagination div.dataTables_info {
        width: 40%;
    }
    .paging_full_numbers {
        height: 22px;
        line-height: 22px;
        width: 400px;
    }
    .paging_full_numbers span.paginate_button, .paging_full_numbers span.paginate_active {
        border: 1px solid #aaa;
        cursor: pointer;
        margin: 0 3px;
        padding: 2px 5px;
    }
    .paging_full_numbers span.paginate_button {
        background-color: #ddd;
    }
    .paging_full_numbers span.paginate_button:hover {
        background-color: #ccc;
    }
    .paging_full_numbers span.paginate_active {
        background-color: #99b3ff;
    }
    table.display tr.even.row_selected td {
        background-color: #b0bed9;
    }
    table.display tr.odd.row_selected td {
        background-color: #9fafd1;
    }
    tr.odd td.sorting_1 {
    }
    tr.odd td.sorting_2 {
        background-color: #dadcff;
    }
    tr.odd td.sorting_3 {
        background-color: #e0e2ff;
    }
    tr.even td.sorting_1 {
    }
    tr.even td.sorting_2 {
        background-color: #f2f3ff;
    }
    tr.even td.sorting_3 {
        background-color: #f9f9ff;
    }
    tr.odd.gradeA td.sorting_1 {
        background-color: #c4ffc4;
    }
    tr.odd.gradeA td.sorting_2 {
        background-color: #d1ffd1;
    }
    tr.odd.gradeA td.sorting_3 {
        background-color: #d1ffd1;
    }
    tr.even.gradeA td.sorting_1 {
        background-color: #d5ffd5;
    }
    tr.even.gradeA td.sorting_2 {
        background-color: #e2ffe2;
    }
    tr.even.gradeA td.sorting_3 {
        background-color: #e2ffe2;
    }
    tr.odd.gradeC td.sorting_1 {
        background-color: #c4c4ff;
    }
    tr.odd.gradeC td.sorting_2 {
        background-color: #d1d1ff;
    }
    tr.odd.gradeC td.sorting_3 {
        background-color: #d1d1ff;
    }
    tr.even.gradeC td.sorting_1 {
        background-color: #d5d5ff;
    }
    tr.even.gradeC td.sorting_2 {
        background-color: #e2e2ff;
    }
    tr.even.gradeC td.sorting_3 {
        background-color: #e2e2ff;
    }
    tr.odd.gradeX td.sorting_1 {
        background-color: #ffc4c4;
    }
    tr.odd.gradeX td.sorting_2 {
        background-color: #ffd1d1;
    }
    tr.odd.gradeX td.sorting_3 {
        background-color: #ffd1d1;
    }
    tr.even.gradeX td.sorting_1 {
        background-color: #ffd5d5;
    }
    tr.even.gradeX td.sorting_2 {
        background-color: #ffe2e2;
    }
    tr.even.gradeX td.sorting_3 {
        background-color: #ffe2e2;
    }
    tr.odd.gradeU td.sorting_1 {
        background-color: #c4c4c4;
    }
    tr.odd.gradeU td.sorting_2 {
        background-color: #d1d1d1;
    }
    tr.odd.gradeU td.sorting_3 {
        background-color: #d1d1d1;
    }
    tr.even.gradeU td.sorting_1 {
        background-color: #d5d5d5;
    }
    tr.even.gradeU td.sorting_2 {
        background-color: #e2e2e2;
    }
    tr.even.gradeU td.sorting_3 {
        background-color: #e2e2e2;
    }
    .ex_highlight #example tbody tr.even:hover, #example tbody tr.even td.highlighted {
        background-color: #ecffb3;
    }
    .ex_highlight #example tbody tr.odd:hover, #example tbody tr.odd td.highlighted {
        background-color: #e6ff99;
    }
    .ex_highlight_row #example tr.even:hover {
        background-color: #ecffb3;
    }
    .ex_highlight_row #example tr.even:hover td.sorting_1 {
        background-color: #ddff75;
    }
    .ex_highlight_row #example tr.even:hover td.sorting_2 {
        background-color: #e7ff9e;
    }
    .ex_highlight_row #example tr.even:hover td.sorting_3 {
        background-color: #e2ff89;
    }
    .ex_highlight_row #example tr.odd:hover {
        background-color: #e6ff99;
    }
    .ex_highlight_row #example tr.odd:hover td.sorting_1 {
        background-color: #d6ff5c;
    }
    .ex_highlight_row #example tr.odd:hover td.sorting_2 {
        background-color: #e0ff84;
    }
    .ex_highlight_row #example tr.odd:hover td.sorting_3 {
        background-color: #dbff70;
    }
    table.KeyTable td {
        border: 3px solid transparent;
    }
    table.KeyTable td.focus {
        border: 3px solid #3366ff;
    }
    table.display tr.gradeA {
        background-color: #eeffee;
    }
    table.display tr.gradeC {
        background-color: #ddddff;
    }
    table.display tr.gradeX {
        background-color: #ffdddd;
    }
    table.display tr.gradeU {
        background-color: #ddd;
    }
    div.box {
        background-color: #e5e5ff;
        border: 1px solid #8080ff;
        height: 100px;
        overflow: auto;
        padding: 10px;
    }
    .MMscrollTable, .dataTables_scrollHeadInner {
        width: 100% !important;
    }
    .MMscrollTable thead tr {
        background: #ffffff;
        cursor: pointer;
        font-weight: normal;
        height: 33px;
    }
    .MMscrollTable thead th .st {
        display: inline-block;
        padding: 0 17px 0 0;
    }
    .MMscrollTable tbody .trover, .MMscrollTable tbody .trover td, .MMscrollTable tbody .trfocus, .MMscrollTable tbody .trfocus td {
        background: none repeat scroll 0 0 #f4f4f4;
    }
    .fx .dataTables_scrollHead {
        width: auto !important;
    }
    .fx.dspno {
        display: block;
        z-index: 0;
    }
    td.colug {
        background: none repeat scroll 0 0 #fff;
        border-color: #dddddd;
        border-style: solid solid none none;
        border-width: 1px 1px medium medium;
        padding: 2px 3px 3px 4px;
    }
    th.bdDotleft {
        border-left: 1px dotted #727272;
        text-align: center;
    }
    th.bdDotright {
        border-right: 1px dotted #727272;
    }
    td.colg {
        background: none repeat scroll 0 0 #fff;
        border-color: #dddddd #cccccc;
        border-style: solid solid none none;
        border-width: 1px 1px medium medium;
        padding: 2px 3px 3px 4px;
    }
    hr.bpop {
        margin: 8px 20px;
        width: 100%;
    }
    .fltl .btn {
        margin-right: 15px;
    }
    .dataTables_scrollBody {
    }
    .MMscrollTable td.leertd, .MMscrollTable th.leertd {
        border-collapse: collapse;
        padding: 0;
        width: 0 !important;
    }
    .MMscrollTableLightWrapper {
        background: none repeat scroll 0 0 #fff;
        padding: 10px;
        width: 740px;
    }
    .MMscrollTableLightBody {
        border: 1px solid #cccccc;
        overflow-x: auto;
        overflow-y: visible;
        padding: 0 0 3px;
    }
    .MMscrollTableLight thead tr.headLight {
        background: none repeat scroll 0 0 #cbddf8;
        border-bottom: 2px solid #ededed;
        font-weight: bold;
        padding: 0 0 5px;
    }
    .MMscrollTableLight thead tr.headLight th {
        background: none repeat scroll 0 0 #cbddf8;
        border-bottom: 2px solid #ededed;
        font-weight: bold;
        padding: 0 0 5px;
    }
    .MMscrollTableLight thead tr.headLight th {
        font-weight: normal;
        padding: 0 4px 4px;
    }
    select.roNew, input.roNew[type="text"] {
        background-color: #ededed !important;
        background-image: none !important;
        border: 1px solid #749dbd !important;
        color: #6d6d6d !important;
    }
    textarea.roNew {
        background: none repeat scroll 0 0 #fefdfd !important;
        border: 1px solid #749dbd !important;
    }
    .MMscrollTable .aleft {
        text-align: left;
    }
    .dataTables_scrollHead {
        overflow: visible !important;
        width: auto !important;
    }
    .dataTables_wrapper {
        padding: 0;
    }
    .dataTables_scrollHead .MMscrollTable {
        border-bottom: 1px solid #99bbe8;
    }
    .dataTables_wrapper {
        border: 1px solid #99bbe8;
    }
    .MMscrollTable th {
        background: none repeat scroll 0 0 #cbddf8;
        font-weight: normal;
        padding-left: 5px;
        vertical-align: middle;
    }
    .MMscrollTableLightWrapper {
        width: auto;
    }
    .MMscrollTable th.sorting_desc, .MMscrollTable th.sorting_asc {
        font-weight: bold;
    }
    .MMscrollTable td.colug, .MMscrollTable td.colg, .MMscrollTable td {
        background: none repeat scroll 0 0 #fff;
        border: 1px solid #ededed;
        padding: 2px 3px 3px 4px;
    }
    .MMscrollTable thead tr {
        height: 28px;
    }
    .MMscrollTable tr.trover td {
        background: none repeat scroll 0 0 #efefef;
    }
    .dataTables_scroll .MMscrollTable {
        border-bottom: 2px solid #ededed;
        width: calc(100% - 1px) !important;
    }
    .MMscrollTable td.tdtool {
        background: none repeat scroll 0 0 #dee7f2;
    }
    .MMscrollTableLight {
        width: 100%;
    }
    
    
    #pageBox .dataTables_wrapper{border: 1px solid #9DBCDA; background:#fff;}
    
    .dataTables_filter {
        float: right;
        position: absolute;
        right: -2px;
        text-align: right;
        top: -30px;
        width: 50%;
    }
    
    .dataTables_filter input{width:200px;}
    
    tr.ownbescheid, tr.ownbescheid td {background: #B4EEB4 !important; }
    tr.ownbescheid td.red {background: #ff0000 !important;}
    
    
    
    .MMscrollTableLightWrapper{width:740px;background:#fff;padding:10px;  width: auto;}
    .MMscrollTableLightBody{overflow:visible; overflow-x:auto; overflow-y:visible; padding: 0 0 3px 0;border: 1px solid #CCCCCC;}
    
    .MMscrollTableLight thead tr.headLight{font-weight:bold; padding:0 0 5px 0;
        background: #CBDDF8;
        border-bottom:2px solid #EDEDED;
    }
    
    .MMscrollTableLight thead tr.headLight th{font-weight:bold; padding:0 0 5px 0;
        background: #CBDDF8;
        border-bottom:2px solid #EDEDED;
    }
    
    
    
    .MMscrollTableLight thead tr.headLight th{padding: 0 4px  4px 4px; font-weight: normal;}
    
    
    
    .MMscrollTableLight{width:100%;}
    .dataTables_scrollHead .MMscrollTable{border-bottom:1px solid #99BBE8;}
    
    #popup_overlay{
        position:absolute;
        left:0;
        right:0;
        top:0;
        bottom:0;
        z-index:100;
        opacity: 0.3;
        /*
            filter: alpha( opacity = 20);
            -moz-opacity:    0.20;
            opacity: 0.20;
            background:#000;
        */
    }
    
    #popup_container {
        font-family: Arial, sans-serif;
        font-size: 12px;
        min-width: 300px; /* Dialog will be no smaller than this */
        max-width: 600px; /* Dialog will wrap after this width */
        background: #FFF;
        border: solid 5px #999;
        color: #000;
        -moz-border-radius: 5px;
        -webkit-border-radius: 5px;
        border-radius: 5px;
        z-index:200;
    }
    
    #popup_title {
        font-size: 14px;
        font-weight: bold;
        text-align: center;
        line-height: 1.75em;
        color: #666;
        border: solid 1px #FFF;
        border-bottom: solid 1px #999;
        cursor: default;
        padding: 0em;
        margin: 0em;
    }
    
    #popup_content {
        padding: 1em 1.75em;
        margin: 0em;
    }
    
    #popup_content.process {
        background-image: none;
        padding: 2em 2em 2em 1em;
        background-repeat:no-repeat;
    }
    
    #pgimg{
        position:absolute;
        left:18px;
        top:45px;
        width:30px;
        height:30px;
    }
    
    #popup_message {
        padding-left: 48px;
    }
    
    .prompt #popup_message{
        text-align:left;
    }
    
    #popup_panel {
        text-align: center;
        margin: 1em 0em 0em 1em;
    }
    
    #popup_prompt {
        margin: .5em 0em;
    }
    
    /*! jQuery UI - v1.9.1 - 2012-10-26
    * http://jqueryui.com
    * Includes: jquery.ui.core.css, jquery.ui.resizable.css, jquery.ui.selectable.css, jquery.ui.accordion.css, jquery.ui.autocomplete.css, jquery.ui.button.css, jquery.ui.datepicker.css, jquery.ui.dialog.css, jquery.ui.menu.css, jquery.ui.progressbar.css, jquery.ui.slider.css, jquery.ui.spinner.css, jquery.ui.tabs.css, jquery.ui.tooltip.css
    * To view and modify this theme, visit http://jqueryui.com/themeroller/?ffDefault=Verdana%2CArial%2Csans-serif&fwDefault=normal&fsDefault=1.1em&cornerRadius=4px&bgColorHeader=cccccc&bgTextureHeader=03_highlight_soft.png&bgImgOpacityHeader=75&borderColorHeader=aaaaaa&fcHeader=222222&iconColorHeader=222222&bgColorContent=ffffff&bgTextureContent=01_flat.png&bgImgOpacityContent=75&borderColorContent=aaaaaa&fcContent=222222&iconColorContent=222222&bgColorDefault=e6e6e6&bgTextureDefault=02_glass.png&bgImgOpacityDefault=75&borderColorDefault=d3d3d3&fcDefault=555555&iconColorDefault=888888&bgColorHover=dadada&bgTextureHover=02_glass.png&bgImgOpacityHover=75&borderColorHover=999999&fcHover=212121&iconColorHover=454545&bgColorActive=ffffff&bgTextureActive=02_glass.png&bgImgOpacityActive=65&borderColorActive=aaaaaa&fcActive=212121&iconColorActive=454545&bgColorHighlight=fbf9ee&bgTextureHighlight=02_glass.png&bgImgOpacityHighlight=55&borderColorHighlight=fcefa1&fcHighlight=363636&iconColorHighlight=2e83ff&bgColorError=fef1ec&bgTextureError=02_glass.png&bgImgOpacityError=95&borderColorError=cd0a0a&fcError=cd0a0a&iconColorError=cd0a0a&bgColorOverlay=aaaaaa&bgTextureOverlay=01_flat.png&bgImgOpacityOverlay=0&opacityOverlay=30&bgColorShadow=aaaaaa&bgTextureShadow=01_flat.png&bgImgOpacityShadow=0&opacityShadow=30&thicknessShadow=8px&offsetTopShadow=-8px&offsetLeftShadow=-8px&cornerRadiusShadow=8px
    * Copyright (c) 2012 jQuery Foundation and other contributors Licensed MIT */.ui-helper-hidden {
                                                                                     display:none
                                                                                 }
    .ui-helper-hidden-accessible {
        position:absolute!important;
        clip:rect(1px,1px,1px,1px)
    }
    .ui-helper-reset {
        margin:0;
        padding:0;
        border:0;
        outline:0;
        line-height:1.3;
        text-decoration:none;
        font-size:100%;
        list-style:none
    }
    .ui-helper-clearfix:before,
    .ui-helper-clearfix:after {
        content:"";
        display:table
    }
    .ui-helper-clearfix:after {
        clear:both
    }
    .ui-helper-clearfix {
        zoom:1
    }
    .ui-helper-zfix {
        width:100%;
        height:100%;
        top:0;
        left:0;
        position:absolute;
        opacity:0;
        filter:Alpha(Opacity=0)
    }
    .ui-state-disabled {
        cursor:default!important
    }
    .ui-icon {
        display:block;
        text-indent:-99999px;
        overflow:hidden;
        background-repeat:no-repeat
    }
    .ui-widget-overlay {
        position:absolute;
        top:0;
        left:0;
        width:100%;
        height:100%
    }
    .ui-resizable {
        position:relative
    }
    .ui-resizable-handle {
        position:absolute;
        font-size:0.1px;
        display:block
    }
    .ui-resizable-disabled .ui-resizable-handle,
    .ui-resizable-autohide .ui-resizable-handle {
        display:none
    }
    .ui-resizable-n {
        cursor:n-resize;
        height:7px;
        width:100%;
        top:-5px;
        left:0
    }
    .ui-resizable-s {
        cursor:s-resize;
        height:7px;
        width:100%;
        bottom:-5px;
        left:0
    }
    .ui-resizable-e {
        cursor:e-resize;
        width:7px;
        right:-5px;
        top:0;
        height:100%
    }
    .ui-resizable-w {
        cursor:w-resize;
        width:7px;
        left:-5px;
        top:0;
        height:100%
    }
    .ui-resizable-se {
        cursor:se-resize;
        width:12px;
        height:12px;
        right:1px;
        bottom:1px
    }
    .ui-resizable-sw {
        cursor:sw-resize;
        width:9px;
        height:9px;
        left:-5px;
        bottom:-5px
    }
    .ui-resizable-nw {
        cursor:nw-resize;
        width:9px;
        height:9px;
        left:-5px;
        top:-5px
    }
    .ui-resizable-ne {
        cursor:ne-resize;
        width:9px;
        height:9px;
        right:-5px;
        top:-5px
    }
    .ui-selectable-helper {
        position:absolute;
        z-index:100;
        border:1px dotted black
    }
    .ui-accordion .ui-accordion-header {
        display:block;
        cursor:pointer;
        position:relative;
        margin-top:2px;
        padding:.5em .5em .5em .7em;
        zoom:1
    }
    .ui-accordion .ui-accordion-icons {
        padding-left:2.2em
    }
    .ui-accordion .ui-accordion-noicons {
        padding-left:.7em
    }
    .ui-accordion .ui-accordion-icons .ui-accordion-icons {
        padding-left:2.2em
    }
    .ui-accordion .ui-accordion-header .ui-accordion-header-icon {
        position:absolute;
        left:.5em;
        top:50%;
        margin-top:-8px
    }
    .ui-accordion .ui-accordion-content {
        padding:1em 2.2em;
        border-top:0;
        overflow:auto;
        zoom:1
    }
    .ui-autocomplete {
        position:absolute;
        top:0;
        cursor:default
    }
    * html .ui-autocomplete {
        width:1px
    }
    .ui-button {
        display:inline-block;
        position:relative;
        padding:0;
        margin-right:.1em;
        cursor:pointer;
        text-align:center;
        zoom:1;
        overflow:visible
    }
    .ui-button,
    .ui-button:link,
    .ui-button:visited,
    .ui-button:hover,
    .ui-button:active {
        text-decoration:none
    }
    .ui-button-icon-only {
        width:2.2em
    }
    button.ui-button-icon-only {
        width:2.4em
    }
    .ui-button-icons-only {
        width:3.4em
    }
    button.ui-button-icons-only {
        width:3.7em
    }
    .ui-button .ui-button-text {
        display:block;
        line-height:1.4
    }
    .ui-button-text-only .ui-button-text {
        padding:.4em 1em
    }
    .ui-button-icon-only .ui-button-text,
    .ui-button-icons-only .ui-button-text {
        padding:.4em;
        text-indent:-9999999px
    }
    .ui-button-text-icon-primary .ui-button-text,
    .ui-button-text-icons .ui-button-text {
        padding:.4em 1em .4em 2.1em
    }
    .ui-button-text-icon-secondary .ui-button-text,
    .ui-button-text-icons .ui-button-text {
        padding:.4em 2.1em .4em 1em
    }
    .ui-button-text-icons .ui-button-text {
        padding-left:2.1em;
        padding-right:2.1em
    }
    input.ui-button {
        padding:.4em 1em
    }
    .ui-button-icon-only .ui-icon,
    .ui-button-text-icon-primary .ui-icon,
    .ui-button-text-icon-secondary .ui-icon,
    .ui-button-text-icons .ui-icon,
    .ui-button-icons-only .ui-icon {
        position:absolute;
        top:50%;
        margin-top:-8px
    }
    .ui-button-icon-only .ui-icon {
        left:50%;
        margin-left:-8px
    }
    .ui-button-text-icon-primary .ui-button-icon-primary,
    .ui-button-text-icons .ui-button-icon-primary,
    .ui-button-icons-only .ui-button-icon-primary {
        left:.5em
    }
    .ui-button-text-icon-secondary .ui-button-icon-secondary,
    .ui-button-text-icons .ui-button-icon-secondary,
    .ui-button-icons-only .ui-button-icon-secondary {
        right:.5em
    }
    .ui-button-text-icons .ui-button-icon-secondary,
    .ui-button-icons-only .ui-button-icon-secondary {
        right:.5em
    }
    .ui-buttonset {
        margin-right:7px
    }
    .ui-buttonset .ui-button {
        margin-left:0;
        margin-right:-.3em
    }
    button.ui-button::-moz-focus-inner {
        border:0;
        padding:0
    }
    .ui-datepicker {
        width:17em;
        padding:.2em .2em 0;
        display:none
    }
    .ui-datepicker .ui-datepicker-header {
        position:relative;
        padding:.2em 0
    }
    .ui-datepicker .ui-datepicker-prev,
    .ui-datepicker .ui-datepicker-next {
        position:absolute;
        top:2px;
        width:1.8em;
        height:1.8em
    }
    .ui-datepicker .ui-datepicker-prev-hover,
    .ui-datepicker .ui-datepicker-next-hover {
        top:1px
    }
    .ui-datepicker .ui-datepicker-prev {
        left:2px
    }
    .ui-datepicker .ui-datepicker-next {
        right:2px
    }
    .ui-datepicker .ui-datepicker-prev-hover {
        left:1px
    }
    .ui-datepicker .ui-datepicker-next-hover {
        right:1px
    }
    .ui-datepicker .ui-datepicker-prev span,
    .ui-datepicker .ui-datepicker-next span {
        display:block;
        position:absolute;
        left:50%;
        margin-left:-8px;
        top:50%;
        margin-top:-8px
    }
    .ui-datepicker .ui-datepicker-title {
        margin:0 2.3em;
        line-height:1.8em;
        text-align:center
    }
    .ui-datepicker .ui-datepicker-title select {
        font-size:1em;
        margin:1px 0
    }
    .ui-datepicker select.ui-datepicker-month-year {
        width:100%
    }
    .ui-datepicker select.ui-datepicker-month,
    .ui-datepicker select.ui-datepicker-year {
        width:49%
    }
    .ui-datepicker table {
        width:100%;
        font-size:.9em;
        border-collapse:collapse;
        margin:0 0 .4em
    }
    .ui-datepicker th {
        padding:.7em .3em;
        text-align:center;
        font-weight:bold;
        border:0
    }
    .ui-datepicker td {
        border:0;
        padding:1px
    }
    .ui-datepicker td span,
    .ui-datepicker td a {
        display:block;
        padding:.2em;
        text-align:right;
        text-decoration:none
    }
    .ui-datepicker .ui-datepicker-buttonpane {
        background-image:none;
        margin:.7em 0 0 0;
        padding:0 .2em;
        border-left:0;
        border-right:0;
        border-bottom:0
    }
    .ui-datepicker .ui-datepicker-buttonpane button {
        float:right;
        margin:.5em .2em .4em;
        cursor:pointer;
        padding:.2em .6em .3em .6em;
        width:auto;
        overflow:visible
    }
    .ui-datepicker .ui-datepicker-buttonpane button.ui-datepicker-current {
        float:left
    }
    .ui-datepicker.ui-datepicker-multi {
        width:auto
    }
    .ui-datepicker-multi .ui-datepicker-group {
        float:left
    }
    .ui-datepicker-multi .ui-datepicker-group table {
        width:95%;
        margin:0 auto .4em
    }
    .ui-datepicker-multi-2 .ui-datepicker-group {
        width:50%
    }
    .ui-datepicker-multi-3 .ui-datepicker-group {
        width:33.3%
    }
    .ui-datepicker-multi-4 .ui-datepicker-group {
        width:25%
    }
    .ui-datepicker-multi .ui-datepicker-group-last .ui-datepicker-header {
        border-left-width:0
    }
    .ui-datepicker-multi .ui-datepicker-group-middle .ui-datepicker-header {
        border-left-width:0
    }
    .ui-datepicker-multi .ui-datepicker-buttonpane {
        clear:left
    }
    .ui-datepicker-row-break {
        clear:both;
        width:100%;
        font-size:0em
    }
    .ui-datepicker-rtl {
        direction:rtl
    }
    .ui-datepicker-rtl .ui-datepicker-prev {
        right:2px;
        left:auto
    }
    .ui-datepicker-rtl .ui-datepicker-next {
        left:2px;
        right:auto
    }
    .ui-datepicker-rtl .ui-datepicker-prev:hover {
        right:1px;
        left:auto
    }
    .ui-datepicker-rtl .ui-datepicker-next:hover {
        left:1px;
        right:auto
    }
    .ui-datepicker-rtl .ui-datepicker-buttonpane {
        clear:right
    }
    .ui-datepicker-rtl .ui-datepicker-buttonpane button {
        float:left
    }
    .ui-datepicker-rtl .ui-datepicker-buttonpane button.ui-datepicker-current {
        float:right
    }
    .ui-datepicker-rtl .ui-datepicker-group {
        float:right
    }
    .ui-datepicker-rtl .ui-datepicker-group-last .ui-datepicker-header {
        border-right-width:0;
        border-left-width:1px
    }
    .ui-datepicker-rtl .ui-datepicker-group-middle .ui-datepicker-header {
        border-right-width:0;
        border-left-width:1px
    }
    .ui-datepicker-cover {
        position:absolute;
        z-index:-1;
        filter:mask();
        top:-4px;
        left:-4px;
        width:200px;
        height:200px
    }
    .ui-dialog {
        position:absolute;
        padding:.2em;
        width:300px;
        overflow:hidden
    }
    .ui-dialog .ui-dialog-titlebar {
        padding:.4em 1em;
        position:relative
    }
    .ui-dialog .ui-dialog-title {
        float:left;
        margin:.1em 16px .1em 0
    }
    .ui-dialog .ui-dialog-titlebar-close {
        position:absolute;
        right:.3em;
        top:50%;
        width:19px;
        margin:-10px 0 0 0;
        padding:1px;
        height:18px
    }
    .ui-dialog .ui-dialog-titlebar-close span {
        display:block;
        margin:1px
    }
    .ui-dialog .ui-dialog-titlebar-close:hover,
    .ui-dialog .ui-dialog-titlebar-close:focus {
        padding:0
    }
    .ui-dialog .ui-dialog-content {
        position:relative;
        border:0;
        padding:.5em 1em;
        background:none;
        overflow:auto;
        zoom:1
    }
    .ui-dialog .ui-dialog-buttonpane {
        text-align:left;
        border-width:1px 0 0 0;
        background-image:none;
        margin:.5em 0 0 0;
        padding:.3em 1em .5em .4em
    }
    .ui-dialog .ui-dialog-buttonpane .ui-dialog-buttonset {
        float:right
    }
    .ui-dialog .ui-dialog-buttonpane button {
        margin:.5em .4em .5em 0;
        cursor:pointer
    }
    .ui-dialog .ui-resizable-se {
        width:14px;
        height:14px;
        right:3px;
        bottom:3px
    }
    .ui-draggable .ui-dialog-titlebar {
        cursor:move
    }
    .ui-menu {
        list-style:none;
        padding:2px;
        margin:0;
        display:block;
        outline:none
    }
    .ui-menu .ui-menu {
        margin-top:-3px;
        position:absolute
    }
    .ui-menu .ui-menu-item {
        margin:0;
        padding:0;
        zoom:1;
        width:100%
    }
    .ui-menu .ui-menu-divider {
        margin:5px -2px 5px -2px;
        height:0;
        font-size:0;
        line-height:0;
        border-width:1px 0 0 0
    }
    .ui-menu .ui-menu-item a {
        text-decoration:none;
        display:block;
        padding:2px .4em;
        line-height:1.5;
        zoom:1;
        font-weight:normal
    }
    .ui-menu .ui-menu-item a.ui-state-focus,
    .ui-menu .ui-menu-item a.ui-state-active {
        font-weight:normal;
        margin:-1px
    }
    .ui-menu .ui-state-disabled {
        font-weight:normal;
        margin:.4em 0 .2em;
        line-height:1.5
    }
    .ui-menu .ui-state-disabled a {
        cursor:default
    }
    .ui-menu-icons {
        position:relative
    }
    .ui-menu-icons .ui-menu-item a {
        position:relative;
        padding-left:2em
    }
    .ui-menu .ui-icon {
        position:absolute;
        top:.2em;
        left:.2em
    }
    .ui-menu .ui-menu-icon {
        position:static;
        float:right
    }
    .ui-progressbar {
        height:2em;
        text-align:left;
        overflow:hidden
    }
    .ui-progressbar .ui-progressbar-value {
        margin:-1px;
        height:100%
    }
    .ui-slider {
        position:relative;
        text-align:left
    }
    .ui-slider .ui-slider-handle {
        position:absolute;
        z-index:2;
        width:1.2em;
        height:1.2em;
        cursor:default
    }
    .ui-slider .ui-slider-range {
        position:absolute;
        z-index:1;
        font-size:.7em;
        display:block;
        border:0;
        background-position:0 0
    }
    .ui-slider-horizontal {
        height:.8em
    }
    .ui-slider-horizontal .ui-slider-handle {
        top:-.3em;
        margin-left:-.6em
    }
    .ui-slider-horizontal .ui-slider-range {
        top:0;
        height:100%
    }
    .ui-slider-horizontal .ui-slider-range-min {
        left:0
    }
    .ui-slider-horizontal .ui-slider-range-max {
        right:0
    }
    .ui-slider-vertical {
        width:.8em;
        height:100px
    }
    .ui-slider-vertical .ui-slider-handle {
        left:-.3em;
        margin-left:0;
        margin-bottom:-.6em
    }
    .ui-slider-vertical .ui-slider-range {
        left:0;
        width:100%
    }
    .ui-slider-vertical .ui-slider-range-min {
        bottom:0
    }
    .ui-slider-vertical .ui-slider-range-max {
        top:0
    }
    .ui-spinner {
        position:relative;
        display:inline-block;
        overflow:hidden;
        padding:0;
        vertical-align:middle
    }
    .ui-spinner-input {
        border:none;
        background:none;
        padding:0;
        margin:.2em 0;
        vertical-align:middle;
        margin-left:.4em;
        margin-right:22px
    }
    .ui-spinner-button {
        width:16px;
        height:50%;
        font-size:.5em;
        padding:0;
        margin:0;
        text-align:center;
        position:absolute;
        cursor:default;
        display:block;
        overflow:hidden;
        right:0
    }
    .ui-spinner a.ui-spinner-button {
        border-top:none;
        border-bottom:none;
        border-right:none
    }
    .ui-spinner .ui-icon {
        position:absolute;
        margin-top:-8px;
        top:50%;
        left:0
    }
    .ui-spinner-up {
        top:0
    }
    .ui-spinner-down {
        bottom:0
    }
    .ui-spinner .ui-icon-triangle-1-s {
        background-position:-65px -16px
    }
    .ui-tabs {
        position:relative;
        padding:.2em;
        zoom:1
    }
    .ui-tabs .ui-tabs-nav {
        margin:0;
        padding:.2em .2em 0
    }
    .ui-tabs .ui-tabs-nav li {
        list-style:none;
        float:left;
        position:relative;
        top:0;
        margin:1px .2em 0 0;
        border-bottom:0;
        padding:0;
        white-space:nowrap
    }
    .ui-tabs .ui-tabs-nav li a {
        float:left;
        padding:.5em 1em;
        text-decoration:none
    }
    .ui-tabs .ui-tabs-nav li.ui-tabs-active {
        margin-bottom:-1px;
        padding-bottom:1px
    }
    .ui-tabs .ui-tabs-nav li.ui-tabs-active a,
    .ui-tabs .ui-tabs-nav li.ui-state-disabled a,
    .ui-tabs .ui-tabs-nav li.ui-tabs-loading a {
        cursor:text
    }
    .ui-tabs .ui-tabs-nav li a,
    .ui-tabs-collapsible .ui-tabs-nav li.ui-tabs-active a {
        cursor:pointer
    }
    .ui-tabs .ui-tabs-panel {
        display:block;
        border-width:0;
        padding:1em 1.4em;
        background:none
    }
    .ui-tooltip {
        padding:8px;
        position:absolute;
        z-index:9999;
        max-width:300px;
        -webkit-box-shadow:0 0 5px #aaa;
        box-shadow:0 0 5px #aaa
    }
    * html .ui-tooltip {
        background-image:none
    }
    body .ui-tooltip {
        border-width:2px
    }
    .ui-widget {
        font-family:Verdana,Arial,sans-serif;
        font-size:1.1em
    }
    .ui-widget .ui-widget {
        font-size:1em
    }
    .ui-widget input,
    .ui-widget select,
    .ui-widget textarea,
    .ui-widget button {
        font-family:Verdana,Arial,sans-serif;
        font-size:1em
    }
    .ui-widget-content {
        border:1px solid #aaa;
        color:#222
    }
    .ui-widget-content a {
        color:#222
    }
    .ui-widget-header {
        border:1px solid #aaa;
        color:#222;
        font-weight:bold
    }
    .ui-widget-header a {
        color:#222
    }
    .ui-state-default,
    .ui-widget-content .ui-state-default,
    .ui-widget-header .ui-state-default {
        border:1px solid #d3d3d3;
        font-weight:normal;
        color:#555
    }
    .ui-state-default a,
    .ui-state-default a:link,
    .ui-state-default a:visited {
        color:#555;
        text-decoration:none
    }
    .ui-state-hover,
    .ui-widget-content .ui-state-hover,
    .ui-widget-header .ui-state-hover,
    .ui-state-focus,
    .ui-widget-content .ui-state-focus,
    .ui-widget-header .ui-state-focus {
        border:1px solid #999;
        font-weight:normal;
        color:#212121
    }
    .ui-state-hover a,
    .ui-state-hover a:hover,
    .ui-state-hover a:link,
    .ui-state-hover a:visited {
        color:#212121;
        text-decoration:none
    }
    .ui-state-active,
    .ui-widget-content .ui-state-active,
    .ui-widget-header .ui-state-active {
        border:1px solid #aaa;
        font-weight:normal;
        color:#212121
    }
    .ui-state-active a,
    .ui-state-active a:link,
    .ui-state-active a:visited {
        color:#212121;
        text-decoration:none
    }
    .ui-state-highlight,
    .ui-widget-content .ui-state-highlight,
    .ui-widget-header .ui-state-highlight {
        border:1px solid #fcefa1;
        color:#363636
    }
    .ui-state-highlight a,
    .ui-widget-content .ui-state-highlight a,
    .ui-widget-header .ui-state-highlight a {
        color:#363636
    }
    .ui-state-error,
    .ui-widget-content .ui-state-error,
    .ui-widget-header .ui-state-error {
        border:1px solid #cd0a0a;
        color:#cd0a0a
    }
    .ui-state-error a,
    .ui-widget-content .ui-state-error a,
    .ui-widget-header .ui-state-error a {
        color:#cd0a0a
    }
    .ui-state-error-text,
    .ui-widget-content .ui-state-error-text,
    .ui-widget-header .ui-state-error-text {
        color:#cd0a0a
    }
    .ui-priority-primary,
    .ui-widget-content .ui-priority-primary,
    .ui-widget-header .ui-priority-primary {
        font-weight:bold
    }
    .ui-priority-secondary,
    .ui-widget-content .ui-priority-secondary,
    .ui-widget-header .ui-priority-secondary {
        opacity:.7;
        filter:Alpha(Opacity=70);
        font-weight:normal
    }
    .ui-state-disabled,
    .ui-widget-content .ui-state-disabled,
    .ui-widget-header .ui-state-disabled {
        opacity:.35;
        filter:Alpha(Opacity=35);
        background-image:none
    }
    .ui-state-disabled .ui-icon {
        filter:Alpha(Opacity=35)
    }
    .ui-icon {
        width:16px;
        height:16px;
    }
    .ui-icon-carat-1-n {
        background-position:0 0
    }
    .ui-icon-carat-1-ne {
        background-position:-16px 0
    }
    .ui-icon-carat-1-e {
        background-position:-32px 0
    }
    .ui-icon-carat-1-se {
        background-position:-48px 0
    }
    .ui-icon-carat-1-s {
        background-position:-64px 0
    }
    .ui-icon-carat-1-sw {
        background-position:-80px 0
    }
    .ui-icon-carat-1-w {
        background-position:-96px 0
    }
    .ui-icon-carat-1-nw {
        background-position:-112px 0
    }
    .ui-icon-carat-2-n-s {
        background-position:-128px 0
    }
    .ui-icon-carat-2-e-w {
        background-position:-144px 0
    }
    .ui-icon-triangle-1-n {
        background-position:0 -16px
    }
    .ui-icon-triangle-1-ne {
        background-position:-16px -16px
    }
    .ui-icon-triangle-1-e {
        background-position:-32px -16px
    }
    .ui-icon-triangle-1-se {
        background-position:-48px -16px
    }
    .ui-icon-triangle-1-s {
        background-position:-64px -16px
    }
    .ui-icon-triangle-1-sw {
        background-position:-80px -16px
    }
    .ui-icon-triangle-1-w {
        background-position:-96px -16px
    }
    .ui-icon-triangle-1-nw {
        background-position:-112px -16px
    }
    .ui-icon-triangle-2-n-s {
        background-position:-128px -16px
    }
    .ui-icon-triangle-2-e-w {
        background-position:-144px -16px
    }
    .ui-icon-arrow-1-n {
        background-position:0 -32px
    }
    .ui-icon-arrow-1-ne {
        background-position:-16px -32px
    }
    .ui-icon-arrow-1-e {
        background-position:-32px -32px
    }
    .ui-icon-arrow-1-se {
        background-position:-48px -32px
    }
    .ui-icon-arrow-1-s {
        background-position:-64px -32px
    }
    .ui-icon-arrow-1-sw {
        background-position:-80px -32px
    }
    .ui-icon-arrow-1-w {
        background-position:-96px -32px
    }
    .ui-icon-arrow-1-nw {
        background-position:-112px -32px
    }
    .ui-icon-arrow-2-n-s {
        background-position:-128px -32px
    }
    .ui-icon-arrow-2-ne-sw {
        background-position:-144px -32px
    }
    .ui-icon-arrow-2-e-w {
        background-position:-160px -32px
    }
    .ui-icon-arrow-2-se-nw {
        background-position:-176px -32px
    }
    .ui-icon-arrowstop-1-n {
        background-position:-192px -32px
    }
    .ui-icon-arrowstop-1-e {
        background-position:-208px -32px
    }
    .ui-icon-arrowstop-1-s {
        background-position:-224px -32px
    }
    .ui-icon-arrowstop-1-w {
        background-position:-240px -32px
    }
    .ui-icon-arrowthick-1-n {
        background-position:0 -48px
    }
    .ui-icon-arrowthick-1-ne {
        background-position:-16px -48px
    }
    .ui-icon-arrowthick-1-e {
        background-position:-32px -48px
    }
    .ui-icon-arrowthick-1-se {
        background-position:-48px -48px
    }
    .ui-icon-arrowthick-1-s {
        background-position:-64px -48px
    }
    .ui-icon-arrowthick-1-sw {
        background-position:-80px -48px
    }
    .ui-icon-arrowthick-1-w {
        background-position:-96px -48px
    }
    .ui-icon-arrowthick-1-nw {
        background-position:-112px -48px
    }
    .ui-icon-arrowthick-2-n-s {
        background-position:-128px -48px
    }
    .ui-icon-arrowthick-2-ne-sw {
        background-position:-144px -48px
    }
    .ui-icon-arrowthick-2-e-w {
        background-position:-160px -48px
    }
    .ui-icon-arrowthick-2-se-nw {
        background-position:-176px -48px
    }
    .ui-icon-arrowthickstop-1-n {
        background-position:-192px -48px
    }
    .ui-icon-arrowthickstop-1-e {
        background-position:-208px -48px
    }
    .ui-icon-arrowthickstop-1-s {
        background-position:-224px -48px
    }
    .ui-icon-arrowthickstop-1-w {
        background-position:-240px -48px
    }
    .ui-icon-arrowreturnthick-1-w {
        background-position:0 -64px
    }
    .ui-icon-arrowreturnthick-1-n {
        background-position:-16px -64px
    }
    .ui-icon-arrowreturnthick-1-e {
        background-position:-32px -64px
    }
    .ui-icon-arrowreturnthick-1-s {
        background-position:-48px -64px
    }
    .ui-icon-arrowreturn-1-w {
        background-position:-64px -64px
    }
    .ui-icon-arrowreturn-1-n {
        background-position:-80px -64px
    }
    .ui-icon-arrowreturn-1-e {
        background-position:-96px -64px
    }
    .ui-icon-arrowreturn-1-s {
        background-position:-112px -64px
    }
    .ui-icon-arrowrefresh-1-w {
        background-position:-128px -64px
    }
    .ui-icon-arrowrefresh-1-n {
        background-position:-144px -64px
    }
    .ui-icon-arrowrefresh-1-e {
        background-position:-160px -64px
    }
    .ui-icon-arrowrefresh-1-s {
        background-position:-176px -64px
    }
    .ui-icon-arrow-4 {
        background-position:0 -80px
    }
    .ui-icon-arrow-4-diag {
        background-position:-16px -80px
    }
    .ui-icon-extlink {
        background-position:-32px -80px
    }
    .ui-icon-newwin {
        background-position:-48px -80px
    }
    .ui-icon-refresh {
        background-position:-64px -80px
    }
    .ui-icon-shuffle {
        background-position:-80px -80px
    }
    .ui-icon-transfer-e-w {
        background-position:-96px -80px
    }
    .ui-icon-transferthick-e-w {
        background-position:-112px -80px
    }
    .ui-icon-folder-collapsed {
        background-position:0 -96px
    }
    .ui-icon-folder-open {
        background-position:-16px -96px
    }
    .ui-icon-document {
        background-position:-32px -96px
    }
    .ui-icon-document-b {
        background-position:-48px -96px
    }
    .ui-icon-note {
        background-position:-64px -96px
    }
    .ui-icon-mail-closed {
        background-position:-80px -96px
    }
    .ui-icon-mail-open {
        background-position:-96px -96px
    }
    .ui-icon-suitcase {
        background-position:-112px -96px
    }
    .ui-icon-comment {
        background-position:-128px -96px
    }
    .ui-icon-person {
        background-position:-144px -96px
    }
    .ui-icon-print {
        background-position:-160px -96px
    }
    .ui-icon-trash {
        background-position:-176px -96px
    }
    .ui-icon-locked {
        background-position:-192px -96px
    }
    .ui-icon-unlocked {
        background-position:-208px -96px
    }
    .ui-icon-bookmark {
        background-position:-224px -96px
    }
    .ui-icon-tag {
        background-position:-240px -96px
    }
    .ui-icon-home {
        background-position:0 -112px
    }
    .ui-icon-flag {
        background-position:-16px -112px
    }
    .ui-icon-calendar {
        background-position:-32px -112px
    }
    .ui-icon-cart {
        background-position:-48px -112px
    }
    .ui-icon-pencil {
        background-position:-64px -112px
    }
    .ui-icon-clock {
        background-position:-80px -112px
    }
    .ui-icon-disk {
        background-position:-96px -112px
    }
    .ui-icon-calculator {
        background-position:-112px -112px
    }
    .ui-icon-zoomin {
        background-position:-128px -112px
    }
    .ui-icon-zoomout {
        background-position:-144px -112px
    }
    .ui-icon-search {
        background-position:-160px -112px
    }
    .ui-icon-wrench {
        background-position:-176px -112px
    }
    .ui-icon-gear {
        background-position:-192px -112px
    }
    .ui-icon-heart {
        background-position:-208px -112px
    }
    .ui-icon-star {
        background-position:-224px -112px
    }
    .ui-icon-link {
        background-position:-240px -112px
    }
    .ui-icon-cancel {
        background-position:0 -128px
    }
    .ui-icon-plus {
        background-position:-16px -128px
    }
    .ui-icon-plusthick {
        background-position:-32px -128px
    }
    .ui-icon-minus {
        background-position:-48px -128px
    }
    .ui-icon-minusthick {
        background-position:-64px -128px
    }
    .ui-icon-close {
        background-position:-80px -128px
    }
    .ui-icon-closethick {
        background-position:-96px -128px
    }
    .ui-icon-key {
        background-position:-112px -128px
    }
    .ui-icon-lightbulb {
        background-position:-128px -128px
    }
    .ui-icon-scissors {
        background-position:-144px -128px
    }
    .ui-icon-clipboard {
        background-position:-160px -128px
    }
    .ui-icon-copy {
        background-position:-176px -128px
    }
    .ui-icon-contact {
        background-position:-192px -128px
    }
    .ui-icon-image {
        background-position:-208px -128px
    }
    .ui-icon-video {
        background-position:-224px -128px
    }
    .ui-icon-script {
        background-position:-240px -128px
    }
    .ui-icon-alert {
        background-position:0 -144px
    }
    .ui-icon-info {
        background-position:-16px -144px
    }
    .ui-icon-notice {
        background-position:-32px -144px
    }
    .ui-icon-help {
        background-position:-48px -144px
    }
    .ui-icon-check {
        background-position:-64px -144px
    }
    .ui-icon-bullet {
        background-position:-80px -144px
    }
    .ui-icon-radio-on {
        background-position:-96px -144px
    }
    .ui-icon-radio-off {
        background-position:-112px -144px
    }
    .ui-icon-pin-w {
        background-position:-128px -144px
    }
    .ui-icon-pin-s {
        background-position:-144px -144px
    }
    .ui-icon-play {
        background-position:0 -160px
    }
    .ui-icon-pause {
        background-position:-16px -160px
    }
    .ui-icon-seek-next {
        background-position:-32px -160px
    }
    .ui-icon-seek-prev {
        background-position:-48px -160px
    }
    .ui-icon-seek-end {
        background-position:-64px -160px
    }
    .ui-icon-seek-start {
        background-position:-80px -160px
    }
    .ui-icon-seek-first {
        background-position:-80px -160px
    }
    .ui-icon-stop {
        background-position:-96px -160px
    }
    .ui-icon-eject {
        background-position:-112px -160px
    }
    .ui-icon-volume-off {
        background-position:-128px -160px
    }
    .ui-icon-volume-on {
        background-position:-144px -160px
    }
    .ui-icon-power {
        background-position:0 -176px
    }
    .ui-icon-signal-diag {
        background-position:-16px -176px
    }
    .ui-icon-signal {
        background-position:-32px -176px
    }
    .ui-icon-battery-0 {
        background-position:-48px -176px
    }
    .ui-icon-battery-1 {
        background-position:-64px -176px
    }
    .ui-icon-battery-2 {
        background-position:-80px -176px
    }
    .ui-icon-battery-3 {
        background-position:-96px -176px
    }
    .ui-icon-circle-plus {
        background-position:0 -192px
    }
    .ui-icon-circle-minus {
        background-position:-16px -192px
    }
    .ui-icon-circle-close {
        background-position:-32px -192px
    }
    .ui-icon-circle-triangle-e {
        background-position:-48px -192px
    }
    .ui-icon-circle-triangle-s {
        background-position:-64px -192px
    }
    .ui-icon-circle-triangle-w {
        background-position:-80px -192px
    }
    .ui-icon-circle-triangle-n {
        background-position:-96px -192px
    }
    .ui-icon-circle-arrow-e {
        background-position:-112px -192px
    }
    .ui-icon-circle-arrow-s {
        background-position:-128px -192px
    }
    .ui-icon-circle-arrow-w {
        background-position:-144px -192px
    }
    .ui-icon-circle-arrow-n {
        background-position:-160px -192px
    }
    .ui-icon-circle-zoomin {
        background-position:-176px -192px
    }
    .ui-icon-circle-zoomout {
        background-position:-192px -192px
    }
    .ui-icon-circle-check {
        background-position:-208px -192px
    }
    .ui-icon-circlesmall-plus {
        background-position:0 -208px
    }
    .ui-icon-circlesmall-minus {
        background-position:-16px -208px
    }
    .ui-icon-circlesmall-close {
        background-position:-32px -208px
    }
    .ui-icon-squaresmall-plus {
        background-position:-48px -208px
    }
    .ui-icon-squaresmall-minus {
        background-position:-64px -208px
    }
    .ui-icon-squaresmall-close {
        background-position:-80px -208px
    }
    .ui-icon-grip-dotted-vertical {
        background-position:0 -224px
    }
    .ui-icon-grip-dotted-horizontal {
        background-position:-16px -224px
    }
    .ui-icon-grip-solid-vertical {
        background-position:-32px -224px
    }
    .ui-icon-grip-solid-horizontal {
        background-position:-48px -224px
    }
    .ui-icon-gripsmall-diagonal-se {
        background-position:-64px -224px
    }
    .ui-icon-grip-diagonal-se {
        background-position:-80px -224px
    }
    .ui-corner-all,
    .ui-corner-top,
    .ui-corner-left,
    .ui-corner-tl {
        -moz-border-radius-topleft:4px;
        -webkit-border-top-left-radius:4px;
        -khtml-border-top-left-radius:4px;
        border-top-left-radius:4px
    }
    .ui-corner-all,
    .ui-corner-top,
    .ui-corner-right,
    .ui-corner-tr {
        -moz-border-radius-topright:4px;
        -webkit-border-top-right-radius:4px;
        -khtml-border-top-right-radius:4px;
        border-top-right-radius:4px
    }
    .ui-corner-all,
    .ui-corner-bottom,
    .ui-corner-left,
    .ui-corner-bl {
        -moz-border-radius-bottomleft:4px;
        -webkit-border-bottom-left-radius:4px;
        -khtml-border-bottom-left-radius:4px;
        border-bottom-left-radius:4px
    }
    .ui-corner-all,
    .ui-corner-bottom,
    .ui-corner-right,
    .ui-corner-br {
        -moz-border-radius-bottomright:4px;
        -webkit-border-bottom-right-radius:4px;
        -khtml-border-bottom-right-radius:4px;
        border-bottom-right-radius:4px
    }
    .ui-widget-overlay {
        opacity:.3;
        filter:Alpha(Opacity=30)
    }
    .ui-widget-shadow {
        margin:-8px 0 0 -8px;
        padding:8px;
        opacity:.3;
        filter:Alpha(Opacity=30);
        -moz-border-radius:8px;
        -khtml-border-radius:8px;
        -webkit-border-radius:8px;
        border-radius:8px
    }
    
    #ui-datepicker-div,.ui-dialog, #ui-datepicker-div td, #ui-datepicker-div th{font-size:.7em;}
    .ui-accordion{font-size:1em;}
    .ui-widget {
        font-family:Verdana,Arial,Helvetica,sans-serif;
    }
    input[type="text"].datepicker{padding:2px 2px 2px 15px; border-width:1px;}
    div.dialog{display:none;}
    .ui-datepicker .ui-datepicker-buttonpane button {padding:0.2em 0.1em 0.3em;margin:0.5em 0.1em 0.4em;font-size:.7em;}
    
    .ui-dialog{
        padding:0;
        border:5px solid #999999;
        border-radius:5px 5px 5px 5px;
    
    }
    .ui-dialog-titlebar{
        border-bottom-right-radius:0 !important;
        border-bottom-left-radius:0 !important;
        border-top-right-radius:0 !important;
        border-top-left-radius:0 !important;
        border-color:#FFFFFF #FFFFFF #999999;
        border-width:1px;
        color:#666666;
        text-align:center !important;
    }
    
    .ui-dialog-titlebar .ui-dialog-title{float:none;}
    
    .dialog .prompt{
        padding:0 0 0 40px;
        font-size:12px;
    
    }
    
    .ui-widget input, .ui-widget select, .ui-widget textarea, .ui-widget button{font-size:12px;}
    
    
    .ui-dialog .ui-dialog-content{padding:1em;}
    .ui-progressbar{height:8px; margin:3px 0;}
    
    .ui-datepicker select.ui-datepicker-month, .ui-datepicker select.ui-datepicker-year {
        font-size: 10px;
    }
    
    .ui-datepicker {
        width: 20em;
    }
    
    .deletedWbb {  padding:10px; background-repeat: repeat; background-position: left; }
    .entwurfWbb {   padding:10px; background-color: #FFA07A; background-repeat: repeat; background-position: left; }
    /*OLD:entwurfWbb {  background-color: #FFA07A; }*/
    .freiggbWbb {  background-color: #B4EEB4; padding:10px;}
    th.gitter {  background-color: #E7E7E7; }
    #contwrapper h5{margin:25px 0 7px 0 !important; color:#000 !important;}
</style>`;